const styles = {
  activeFilters: {
    display: "flex",
    flexWrap: "wrap",
    gap: "8px",
    marginBottom: "16px",
  },
  activeFilterChip: {
    display: "flex",
    alignItems: "center",
    gap: "6px",
    background: "#f3f2f9",
    color: "#4b3f8f",
    borderRadius: "12px",
    padding: "4px 8px 4px 12px",
    fontSize: "0.85rem",
  },
  activeFilterRemove: {
    border: "none",
    background: "none",
    color: "inherit",
    font: "inherit",
    fontWeight: "bold",
    cursor: "pointer",
    padding: 0,
    lineHeight: 1,
  },
};

function ActiveFilterChips({ items, onClear }) {
  if (items.length === 0) {
    return null;
  }

  return (
    <div style={styles.activeFilters}>
      {items.map((item) => (
        <span key={item.key} style={styles.activeFilterChip}>
          {item.label}: {item.value}
          <button
            type="button"
            style={styles.activeFilterRemove}
            onClick={() => onClear(item.groupKey, item.filterKey)}
            aria-label={`${item.label}の条件を解除`}
          >
            ×
          </button>
        </span>
      ))}
    </div>
  );
}

export default ActiveFilterChips;
